"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Screenshot = void 0;
const i18next_1 = __importDefault(require("i18next"));
const Toast_1 = require("./../toast/Toast");
const ScreenshotControls_1 = require("./components/ScreenshotControls");
class Screenshot {
    constructor(webgl) {
        this.webgl = webgl;
        const parentEl = document.getElementById('screenshot');
        if (!parentEl) {
            throw new Error("Parent element (screenshot) is undefined");
        }
        this.screenshotControls = new ScreenshotControls_1.ScreenshotControls(parentEl);
        this.addEvents();
        this.getThumbnail();
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.dispose();
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.screenshotButton) === null || _b === void 0 ? void 0 : _b.setEvent('click', () => {
            this.screenshot();
        });
        (_d = (_c = this.screenshotControls) === null || _c === void 0 ? void 0 : _c.downloadButton) === null || _d === void 0 ? void 0 : _d.setEvent('click', () => {
            this.downloadImage();
        });
        (_f = (_e = this.screenshotControls) === null || _e === void 0 ? void 0 : _e.uploadButton) === null || _f === void 0 ? void 0 : _f.setEvent('click', () => {
            this.uploadThumbnail();
        });
    }
    getThumbnail() {
        PubSub.publish("get-thumbnail-url" /* GET_THUMBNAIL_URL */, (blobUrl) => {
            this.imageUrl = blobUrl;
            this.setImage();
        });
    }
    setImage() {
        var _a, _b;
        (_b = (_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.screenshotedImage) === null || _b === void 0 ? void 0 : _b.addAttribute('src', this.imageUrl || '');
    }
    screenshot() {
        var _a;
        let backgroundBackup;
        if ((_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.makeTransparentBackground) {
            backgroundBackup = this.webgl.scene.background;
            this.webgl.scene.background = null;
        }
        PubSub.publish("take-screenshot" /* TAKE_SCREENSHOT */, (blob) => {
            var _a;
            if ((_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.makeTransparentBackground) {
                this.webgl.scene.background = backgroundBackup;
                this.webgl.renderOnce();
            }
            this.imageBlob = blob;
            this.imageUrl = URL.createObjectURL(blob);
            this.setImage();
            Toast_1.Toast.create('success', i18next_1.default.t("SCREENSHOT_CREATED"));
        });
    }
    uploadThumbnail() {
        if (!this.imageBlob) {
            return;
        }
        PubSub.publish("upload-thumbnail" /* UPLOAD_THUMBNAIL */, this.imageBlob);
    }
    downloadImage() {
        if (!this.imageUrl) {
            return;
        }
        var a = document.createElement('a');
        a.href = this.imageUrl;
        a.download = 'model_screenshot.png';
        a.click();
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (_c = (_b = (_a = this.screenshotControls) === null || _a === void 0 ? void 0 : _a.screenshotButton) === null || _b === void 0 ? void 0 : _b.domEl) === null || _c === void 0 ? void 0 : _c.removeAllListeners();
        (_f = (_e = (_d = this.screenshotControls) === null || _d === void 0 ? void 0 : _d.downloadButton) === null || _e === void 0 ? void 0 : _e.domEl) === null || _f === void 0 ? void 0 : _f.removeAllListeners();
        (_j = (_h = (_g = this.screenshotControls) === null || _g === void 0 ? void 0 : _g.uploadButton) === null || _h === void 0 ? void 0 : _h.domEl) === null || _j === void 0 ? void 0 : _j.removeAllListeners();
    }
}
exports.Screenshot = Screenshot;
